import { useEffect, useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';

import { getMybizDashboard } from '@/api/pc-api/v1/mybiz/list/dashboard';
import PageLoading from '@/components/Loading/PageLoading';
import PageHeader from '@/components/PageHeader';
import { FrontPopupErrorStatus } from '@/constants/error/frontErrorStatus';
import { useInitialPageFetch } from '@/hooks/useInitialPageFetch';
import { useForm } from '@/lib/react-hook-form/useForm';
import MyBizInput from '@/pages/root/components/MyBizInput';
import MyBizListEmpty from '@/pages/root/components/MyBizListEmpty';
import MyBizSearchResult from '@/pages/root/components/MyBizSearchResult';
import REGISTER_NAME from '@/pages/root/constants/registerName';
import { handlePopupError } from '@/utils/globalErrorHandler';
import { withTiara } from '@/utils/withTiara';

export type DashboardQuery = {
  companyName: string;
  page: number;
};

type FormData = {
  [REGISTER_NAME.MY_BIZ]: string;
};

const RootPage = () => {
  const initialMyBizList = useInitialPageFetch(() => getMybizDashboard({ companyName: '', page: 1 }));
  const [searchParams] = useSearchParams();
  const isInitialMyBizList = !!initialMyBizList?.data.length;
  const [query, setQuery] = useState<DashboardQuery>({ companyName: '', page: 1 });

  const formMethods = useForm<FormData>({
    defaultValues: {
      [REGISTER_NAME.MY_BIZ]: ''
    }
  });

  const updateCompanyName = () => {
    const { myBiz } = formMethods.getValues();
    setQuery({ companyName: myBiz, page: 1 });
  };

  const updatePage = (page: number) => {
    setQuery((prev) => ({ ...prev, page }));
  };

  useEffect(() => {
    const isNotMatchedLogin = searchParams.get('notMatchedLogin') === 'true';
    if (isNotMatchedLogin) {
      handlePopupError(FrontPopupErrorStatus.INVITED_ACCOUNT_NOT_MATCHED);
    }
  }, []);

  if (!initialMyBizList) return <PageLoading />;

  return (
    <FormProvider {...formMethods}>
      <PageHeader
        title="MY BIZ"
        description="지갑파트너센터에서 이용할 서비스와 이용기관을 선택하세요."
        helpFor="HOME_MY_BIZ"
      />
      {isInitialMyBizList ? (
        <>
          <MyBizInput updateCompanyName={updateCompanyName} />
          <MyBizSearchResult initialMyBizData={initialMyBizList} query={query} updatePage={updatePage} />
        </>
      ) : (
        <div className="wrap_list_mybiz">
          <MyBizListEmpty title="연결된 이용기관이 없습니다." description="이용기관 관리자에게 초대를 요청해 주세요." />
        </div>
      )}
    </FormProvider>
  );
};

export default withTiara(RootPage, { pageKey: 'ROOT' });
